__turbopack_context__.v({
  "centerDiv": "wDMM2q_centerDiv",
  "pane": "wDMM2q_pane",
  "paneContainer": "wDMM2q_paneContainer",
  "paneTitle": "wDMM2q_paneTitle",
});
